"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataTable_1 = require("./components/DataTable/DataTable");
Object.defineProperty(exports, "DataTable", { enumerable: true, get: function () { return DataTable_1.default; } });
var TreeTable_1 = require("./components/TreeTable/TreeTable");
Object.defineProperty(exports, "TreeTable", { enumerable: true, get: function () { return TreeTable_1.default; } });
//# sourceMappingURL=main.js.map